module.exports = __webpack_public_path__ + "media/images/icons/icon_kebab-cc3e6231d607f22e665e841cc48f0061.svg";